import type { CapiProductPage } from 'types/capi/pdp';

import usePageData from '~/hooks/usePageData';
import useRegion from '~/hooks/useRegion';
import gtm from '~/services/gtm.client';

import ProductCardCarousel from './ProductCardCarousel';

const WhatsHot = () => {
  const product = usePageData<CapiProductPage>();

  const sendGtmEvent = () => {
    gtm.sendUserInteractionEvent("What's Hot View More Drops", 'Body');
  };

  return (
    <ProductCardCarousel
      title="What's Hot"
      viewMoreCopy="View more drops"
      onViewMoreProductsClick={sendGtmEvent}
      viewMoreUrl={product.view_more_products_path}
      id="featured-products"
      products={product.featured_products}
      padImages={product.pad_images}
      allowNotifications={product.allow_user_notifications}
    />
  );
};

const RelatedProducts = () => {
  const product = usePageData<CapiProductPage>();

  return (
    <ProductCardCarousel
      title="Similar products"
      id="similar-products"
      products={product.related_products}
      padImages={product.pad_images}
      allowNotifications={product.allow_user_notifications}
    />
  );
};

const ProductCardCarousels = () => {
  const products = usePageData<CapiProductPage>();
  const region = useRegion();

  const showRelatedProductCarousel = products.related_products.length !== 0;

  if (region.code !== 'GB') return null;

  return (
    <div className="flex flex-col gap-4 bg-concrete">
      {showRelatedProductCarousel && (
        <>
          <div className="mx-auto max-w-desktop p-3 md:px-8 desktop:px-0">
            <RelatedProducts />
          </div>
          <hr className="w-full border-grey-midnight-read" />
        </>
      )}

      <div className="mx-auto max-w-desktop p-3 md:px-8 desktop:px-0">
        <WhatsHot />
      </div>
    </div>
  );
};

export default ProductCardCarousels;
